import { DetailedHTMLProps, FC, ReactNode, TdHTMLAttributes } from 'react';

import classNames from 'classnames';

import './TableCell.scss';

import { TestMetadata } from '../types';

export interface Props
  extends DetailedHTMLProps<
    TdHTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  > {
  /** Cell's content */
  children?: ReactNode;
  /** Cell's classname */
  className?: string;
  /** Col span of cell */
  colSpan?: number;
  wrap?: boolean;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const TableCell: FC<Props> = ({
  children,
  className,
  colSpan = 1,
  wrap = false,
  testMetadata,
  ...otherProps
}) => {
  return (
    <td
      {...otherProps}
      className={classNames(
        'sb-table-cell',
        {
          'sb-table-cell-wrap': wrap,
        },
        className,
      )}
      colSpan={colSpan}
      {...testMetadata}
    >
      {children}
    </td>
  );
};

export default TableCell;
